/* eslint-disable @typescript-eslint/interface-name-prefix */
/* eslint-disable @typescript-eslint/no-explicit-any */

import Axios from 'axios'
import { Log } from '@/services/log'
// eslint-disable-next-line import/no-named-default
import { default as conf } from '@/assets/config/general.json'

const logger = new Log()
const cfg = conf.url_service

export interface IConexion {
    _baseUrl: string;
    _tipo: 'get' | 'post' | 'GET' | 'delete' | 'DELETE' | 'head' | 'HEAD' | 'options' | 'OPTIONS' | 'POST' | 'put' | 'PUT' | 'patch' | 'PATCH' | undefined | string;
    _request: string | null;
    _params: any | null;
    _data: any | null;
    _result: any | null;
    _header: Record<string, any>;
    _crossDomain: boolean;
}

export default class Conexion implements IConexion {
    public _baseUrl = cfg.protocolo + '://' + cfg.ip + ':' + cfg.puerto;
    public _tipo = 'get';
    public _request = '';
    public _params = [];
    public _data = [];
    public _result = [];
    public _header = {
      accept: 'application/json',
      'accept-language': 'en_US',
      'content-type': 'application/json'
    };

    public _crossDomain = true;

    constructor (request = '', params: any = [], tipo = 'get') {
      this._request = request
      this._params = params
      this._tipo = tipo
    }

    get baseUrl (): string { return this._baseUrl }
    set baseUrl (n: string) { this._baseUrl = n }
    get tipo (): string | any { return this._tipo }
    set tipo (n: string | any) { this._tipo = n }
    get request (): string { return this._request }
    set request (n: string) { this._request = n }
    get params () { return this._params }
    set params (n) { this._params = n }
    get data () { return this._data }
    set data (n) { this._data = n }
    get result () { return this._result }
    set result (n) { this._result = n }
    get header () { return this._header }
    set header (n) { this._header = n }
    get crossDomain () { return this._crossDomain }
    set crossDomain (n) { this._crossDomain = n }

    get peticion () {
      return {
        method: this.tipo,
        url: this.baseUrl + this.request,
        data: this.data,
        params: this.params,
        headers: this.header,
        crossDomain: this.crossDomain
      }
    }

    async consultar () {
      switch (this._tipo) {
        case 'post':
          this.data = this._params
          this.params = []
          break
        case 'get':
          this.data = []
          break
        default:
          logger.error('El metodo de envio no es valido')
          return
      }

      return Axios(this.peticion)
        .catch(error => (logger.error(error, { error: error })))
        .then((response: any) => { return (response !== undefined) ? response.data : null })
    }
}
